import http from '../http';

export function getChannelSetting(channelId, type) {
  const params = type ? { channelId, type } : { channelId }
  return http.get(`/andes/simulation/channel/setting`, { params })
}

/**
 * @export
 * @param {*} { channelId, type } type - RETURN_LOSS, INSERTION_LOSS, DIFF_TO_COMM, TDR, SBR, DELAY
 * @returns
 */
export function getChannelExtractionResult({ channelId, type, pair, signal }) {
  return http.get(`/andes/simulation/channel/extraction/results`, { params: { channelId, type, pair, signal } })
}

export function getChannelWaveformResultList({ channelId, displayMode }) {
  return http.get(`/andes/channel/hspice/waveform`, { params: { channelId, displayMode } })
}

export function getAndesHspiceResultEyeDiagram({ channelId, signal }) {
  return http.get(`/andes/channel/hspice/eye`, {
    params: {
      channelId,
      signalName: signal
    },
    responseType: 'arraybuffer'
  });
}

export function getAndesHspiceResultEyeParameters({ channelId, signal }) {
  return http.get(`/andes/channel/hspice/eye/measurement?channelId=${channelId}&signalName=${signal}`)
}

/**
 * type: HSPICE_WAVEFORM, HSPICE_EYE_DIAGRAM, HSPICE_EYE_MEASUREMENT
 * @returns 
 */
export function getHistoryChannelResultList({ historyId, displayMode, signalName, type, responseType }) {
  return http.get(`andes/result/history/hspice/result`, { params: { historyId, displayMode, signalName, type }, responseType })
}

export function getEndToEndChannelResultList({ endToEndChannelId, displayMode, signalName, type, responseType }) {
  return http.get(`/andes/end-to-end/channel/hspice/result`, { params: { endToEndChannelId, displayMode, signalName, type }, responseType })
}

export function getHistoryEndToEndChannelResultList({ historyId, displayMode, signalName, type, responseType }) {
  return http.get(`/andes/end-to-end/channel/history/hspice/result`, { params: { historyId, displayMode, signalName, type }, responseType })
}

/**
 * Get sparameter curve
 *
 * @export
 * @param {*} channelId
 * @param {*} resultDataParam
 * @returns
 */
export function getResultCurveData({ channelId, resultDataParam, signal, pair, couplingType }) {
  let otherParam = '';
  if (signal && pair) {
    otherParam += `&signal=${signal}&pair=${pair}`;
  }
  if (couplingType) {
    otherParam += `&type=${couplingType}`;
    return http.post(`/andes/channel/curve/data?channelId=${channelId}${otherParam}`, {})
  }
  return http.post(`/andes/channel/curve/data?channelId=${channelId}${otherParam}`, resultDataParam)
}

/**
 * Generate TDR, SBR
 * 
 * @export
 * @param {*} params
 * {
  "channelId": "string",
  "datarate": "string",
  "delay_risetime": "string",
  "duration_ratio": 0,
  "sbr_delay": "string",
  "sbr_risetime": "string",
  "tdr_delay": "string",
  "tdr_risetime": "string"
}
 * @returns
 */
export function generateTDRSBR(params) {
  return http.post(`/andes/simulation/channel/result-parser`, params)
}

/**
 *
 * Get TDR, SBR Setting
 * 
 * @export
 * @param {*} channelId - channel id
 * @returns
 * { 
 *  "data": {
 *   "channelId": "string",
 *   "datarate": "string",
 *   "delay_risetime": "string",
 *   "duration_ratio": 0,
 *   "sbr_delay": "string",
 *   "sbr_risetime": "string",
 *   "tdr_delay": "string",
 *   "tdr_risetime": "string"
 *  } 
 * }
 */
export function getTDRSBRSetting(channelId) {
  return http.get(`/andes/simulation/channel/result/setting`, { params: { channelId } })
}

/**
 * Delete history folder by ids
 *
 * @export
 * @param {*} ids
 * @returns
 */
export function deleteHistoryFolder(ids) {
  return http.post(`/andes/result/history/delete`, { ids })
}

/**
 * Get history list by channel id
 *
 * @export
 * @param {*} channelId
 * @returns
 */
export function getHistoryList(channelId) {
  return http.get(`/andes/result/history/list`, { params: { channelId } })
}

/**
 * Rename result history
 *
 * @export
 * @param {*} id
 * @param {*} name
 * @returns
 */
export function renameResultHistory(id, name) {
  return http.post(`/andes/result/history/rename`, { id, name })
}

/**
 * Get history results by history id and type
 *
 * @export
 * @param {*} { historyId, type }
 * type - RETURN_LOSS, INSERTION_LOSS, DIFF_TO_COMM, TDR, SBR, DELAY, SPARAMETER
 * @returns
 */
export function getHistoryResults({ historyId, type, pair, signal }) {
  return http.get(`/andes/result/history/results`, { params: { historyId, type, pair, signal } })
}

/**
 *  Save current results to history
 *
 * @export
 * @param {*} { channelId, name }
 * @returns
 */
export function saveToHistory({ channelId, name }) {
  return http.post(`/andes/result/history/save`, {
    channelId,
    name
  })
}

/**
 * Get history setting
 *
 * @export
 * @param {*} historyId
 */
export function getHistorySetting(historyId, type) {
  const params = type ? { historyId, type } : { historyId }
  return http.get(`/andes/result/history/setting`, { params })
}

/**
 * Get channel last simulation finished time
 *
 * @export
 * @param {*} channelId
 * @returns
 */
export function getChannelFinishedTime(channelId) {
  return http.get(`/andes/result/history/time`, { params: { channelId } })
}

export function getHistoryCurveData({ historyId, signal, pair, resultDataParam, couplingType }) {
  let otherParam = '';
  if (signal && pair) {
    otherParam = `&signal=${signal}&pair=${pair}`
  }
  if (couplingType) {
    otherParam += `&type=${couplingType}`;
    return http.post(`/andes/result/history/curve/data?historyId=${historyId}${otherParam}`, {});
  }
  return http.post(`/andes/result/history/curve/data?historyId=${historyId}${otherParam}`, resultDataParam)
}

export function getEndToEndChannelSetting(endToEndChannelId, type) {
  return http.get(`/andes/end-to-end/channel/setting`, { params: { endToEndChannelId, type } })
}

/**
 *
 *
 * @export
 * @param {*} { channelId, type } type - RETURN_LOSS, INSERTION_LOSS, DIFF_TO_COMM, TDR, SBR, DELAY
 * @returns
 */
export function getEndToEndChannelResult({ endToEndChannelId, type, pair, signal }) {
  return http.get(`/andes/end-to-end/channel/results`, { params: { endToEndChannelId, type, pair, signal } })
}

export function getEndToEndCurveData({ endToEndChannelId, resultDataParam, signal, pair, couplingType }) {
  let otherParam = '';
  if (signal && pair) {
    otherParam += `&signal=${signal}&pair=${pair}`;
  }
  if (couplingType) {
    otherParam += `&type=${couplingType}`;
    return http.post(`/andes/end-to-end/channel/curve/data?endToEndChannelId=${endToEndChannelId}${otherParam}`, {})
  }
  return http.post(`/andes/end-to-end/channel/curve/data?endToEndChannelId=${endToEndChannelId}${otherParam}`, resultDataParam)
}

export function getEndToEndTDRSBRSetting(id) {
  return http.get(`/andes/end-to-end/channel/raw/setting`, { params: { channelId: id } })
}

export function generateEndToEndTDRSBR(params) {
  return http.post(`/andes/end-to-end/channel/result-parser`, params)
}

/**
 * get pre layout setup json by channelId
 *  */
export function getAndesPreLayoutJson(channelId) {
  return http.get(`/andes/channel/prelayout/detail?channelId=${channelId}`);
}

/**
 * get channel ads result eye diagram
 *  */
export function getAndesAdsResultEyeDiagram({ channelId, signal, probe }) {
  return http.get(`/andes/channel/ads/result/eyediagram`, {
    params: {
      channelId,
      signalName: signal,
      probe
    },
    responseType: 'arraybuffer'
  });
}

export function getAndesAdsResultHistoryEyeDiagram({ historyId, signal, probe }) {
  return http.get(`/andes/result/history/ads/eye-diagram`, {
    params: {
      historyId,
      signal,
      probe
    },
    responseType: 'arraybuffer'
  });
}

/**
 * get channel ads result eye diagram parameters
 *  */
export function getAndesAdsResultEyeParameters({ channelId, signal, probe }) {
  return http.get(`/andes/channel/ads/result/parameter`, { params: { channelId, signalName: signal, probe } })
}

/**
 * get channel ads result eye diagram parameters
 *  */
export function getAndesAdsResultHistoryEyeParameters({ historyId, signal, probe }) {
  return http.get(`/andes/result/history/ads/parameter`, { params: { historyId, signal, probe } })
}

/**
 * get multi pcb ads result eye diagram
 *  */
export function getAndesEndToEndAdsEyeDiagram({ endToEndChannelId, signal, probe }) {
  return http.get(`/andes/end-to-end/channel/ads/result/eye-diagram`, {
    params: {
      endToEndChannelId,
      signalName: signal,
      probe
    },
    responseType: 'arraybuffer'
  });
}

export function getAndesEndToEndAdsHisEyeDiagram({ historyId, signal, probe }) {
  return http.get(`/andes/end-to-end/channel/history/ads/eye-diagram`, {
    params: {
      historyId,
      signal,
      probe
    },
    responseType: 'arraybuffer'
  });
}

/**
 * get channel ads result eye diagram parameters
 *  */
export function getAndesEndToEndAdsEyeParameters({ endToEndChannelId, signal, probe }) {
  return http.get(`/andes/end-to-end/channel/ads/result/parameter`, { params: { endToEndChannelId, signalName: signal, probe } })
}

/**
 * get channel ads result eye diagram parameters
 *  */
export function getEndToEndAndesAdsHistoryEyeParameters({ historyId, signal, probe }) {
  return http.get(`/andes/end-to-end/channel/history/ads/parameter`, { params: { historyId, signal, probe } })
}

/** 
 * 2024.06.27
 * @param {*} { experimentId, type } type - RETURN_LOSS, INSERTION_LOSS, DIFF_TO_COMM, TDR, SBR, DELAY
 * @return
 */
export function getSweepExtractionResult({ experimentId, type }) {
  return http.get(`/andes/simulation/sweep-channel/extraction/results`, { params: { experimentId, type } });
}

export function getExperimentSetting(experimentId, type) {
  const params = type ? { experimentId, type } : { experimentId }
  return http.get(`/andes/simulation/sweep-channel/setting`, { params })
}

export function getExperimentCurveData({ experimentId, resultDataParam }) {
  return http.post(`/andes/channel/curve/sweep/result?experimentId=${experimentId}`, resultDataParam)
}

export function getSweepTDRSBRSetting(sweepId) {
  return http.get(`/andes/simulation/sweep-channel/result/setting?sweepId=${sweepId}`)
}

export function generateSweepTDRSBR({ params, sweepId }) {
  return http.post(`/andes/simulation/sweep-channel/result-parser?sweepId=${sweepId}`, params)
}


// Bathtub 
export function getChannelBathtubResultList({ channelId, rawFileName, signalName }) {
  return http.get(`/andes/channel/ads/bathtub/raw`, { params: { channelId, rawFileName, signalName } })
}

export function getEndToEndBathtubResultList({ endToEndChannelId, rawFileName, signalName }) {
  return http.get(`/andes/end-to-end/channel/ads/bathtub/raw`, { params: { endToEndChannelId, rawFileName, signalName } })
}

export function getChannelBathtubRawFile({ channelId, signalName }) {
  return http.get(`/andes/channel/ads/bathtub/list`, { params: { channelId, signalName } })
}

export function getEndToEndBathtubRawFile({ endToEndChannelId, signalName }) {
  return http.get(`/andes/end-to-end/channel/ads/bathtub/list`, { params: { endToEndChannelId, signalName } })
}

export function generateEyeDiagram({ channelId, config }) {
  return http.post(`/andes/simulation/c-phy/eye-diagram/generation?channelId=${channelId}`, config)
}